module.exports = __webpack_public_path__ + "images/stickers/pete-vacation@2x.d5b2dd95e12c57819c88.png";